export default __webpack_public_path__ + "static/media/user.8cab7b59.svg";